import { render, staticRenderFns } from "./AffairsSection.vue?vue&type=template&id=46414af6&scoped=true"
import script from "./AffairsSection.vue?vue&type=script&lang=js"
export * from "./AffairsSection.vue?vue&type=script&lang=js"
import style0 from "./AffairsSection.vue?vue&type=style&index=0&id=46414af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46414af6",
  null
  
)

export default component.exports